import { Outlet } from "react-router";
import { Footer } from "./Footer";

export function AuthLayout() {
	return (
		<div className="min-h-screen flex flex-col bg-gray-50">
			<div className="flex-1 flex items-center justify-center">
				<div className="max-w-sm w-full p-6 bg-white rounded-lg shadow">
					<Outlet />
				</div>
			</div>
			<Footer />
		</div>
	);
}
